import '../../modules/mode-components';

import * as angular from 'angular';
import * as $ from 'jquery';

angular.module('mode.components').directive('tokenfield', [
  function () {
    return {
      scope: {
        onTokenCreated: '&',
        onTokenCreating: '&',
        onTokenRemoved: '&',
      },

      link: function (scope: any, element, attrs) {
        element
          .on('tokenfield:initialize', function () {
            $(this).data('bs.tokenfield').$input.prop('autofocus', true);
          })
          .tokenfield({
            createTokensOnBlur: true,
          });

        element.on('tokenfield:createdtoken', function (e) {
          scope.onTokenCreated({ $event: e, $tokens: element.tokenfield('getTokens') });
        });

        element.on('tokenfield:createtoken', function (e) {
          return scope.onTokenCreating({ $event: e, $tokens: element.tokenfield('getTokens') });
        });

        element.on('tokenfield:removedtoken', function (e) {
          scope.onTokenRemoved({ $event: e, $tokens: element.tokenfield('getTokens') });
        });
      },
    };
  },
]);
